import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const itemListTodo = createAsyncThunk('itemList', async ({ pageable, data, navigate }) => {
    const payload = pageable || data
    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `item_master`,
            params: {
                'pageSize': payload?.pageSize,
                'pageNo': payload?.currentPage,
                'search': payload?.search,
                'type': payload?.type || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const itemListSlice = createSlice({
    name: 'itemList',
    initialState: {
        data: [],
    },
    reducers: {
        removeItems: (state, action) => {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(itemListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }


        });
        builder.addCase(itemListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export const { removeItems } = itemListSlice.actions;
export default itemListSlice.reducer; 